const apiBaseUrl = (import.meta.env.VITE_API_BASE_URL || '').replace(/\/+$/, '');

export const INTEGRATION_ACTIONS = {
  hubspot: (userId?: string) => `${apiBaseUrl}/auth/hubspot?u=${userId}`,
  salesforce: (userId?: string) => `${apiBaseUrl}/auth/salesforce?u=${userId}`,
  linkedin: (userId?: string) => `${apiBaseUrl}/auth/linkedin?u=${userId}`,
  calendly: (userId?: string) => `${apiBaseUrl}/auth/calendly?u=${userId}`,
  pipedrive: (userId?: string) => `${apiBaseUrl}/auth/pipedrive?u=${userId}`,
  zohoCRM: (userId?: string) => `${apiBaseUrl}/auth/zoho?u=${userId}`,
  microsoftDynamics: null, // Uses modal
  twentyCRM: null, // Uses modal
  outlookCalendar: () => `${apiBaseUrl}/auth/microsoft?calendar=true&settings=true`,
  /**
   * Opens the Commander app on Zapier's platform in a new tab.
   * The user clicks "Connect Commander" there, which initiates the OAuth
   * authorization-code flow (U1) against this Commander instance.
   *
   * Use VITE_ZAPIER_APP_URL to override the default URL.
   */
  zapier: () => {
    const zapierAppUrl =
      import.meta.env.VITE_ZAPIER_APP_URL || 'https://zapier.com/apps/commanderai';
    if (import.meta.env.DEV && !import.meta.env.VITE_ZAPIER_APP_URL) {
      console.warn(
        '[Integrations] VITE_ZAPIER_APP_URL not set, using default: https://zapier.com/apps/commanderai'
      );
    }
    return zapierAppUrl;
  },
} as const;

export const getDynamicsAuthUrl = (userId: string, orgUrl: string) =>
  `${apiBaseUrl}/auth/dynamics?u=${userId}&org=${orgUrl}`;
